
import { Component, Vue } from "vue-property-decorator";
import { Caxios } from "./../../../utils/axios";

@Component({
  name: "DashSwiper",
})
export default class DashSwiper extends Vue {
  private picLists: Array<any> = [];
  private allWidth: number = 0;
  private singleWidth: number = 0;
  // private singleHeight: number = document.documentElement.clientWidth * 360 / 1200;
  private singleHeight: number = document.documentElement.clientWidth * 380 / 1920;
  private leftPos: number = 0;
  private timer: any = null;
  private interval: number = 3000;
  private animated: boolean = false;
  private moveIndex: number = 1;
  private dotsList: Array<number> = []

  private async initPics() {
    let _res: any = await Caxios.get({ url: `/api/pics/web?webPageType=english` }),
      _len: number = _res.length;
    this.dotsList = new Array(_len).fill(0)
    this.singleWidth = document.documentElement.clientWidth;
    this.picLists = [_res[_len - 1]].concat([..._res, _res[0]]);
    this.allWidth = this.singleWidth * this.picLists.length;
    let img_url = _res[0].picurl,
      img = new Image(); // 创建对象
    img.src = img_url; // 改变图片的src
    this.singleHeight = Math.floor((this.singleWidth * img.height) / img.width);
    this.leftPos = -this.singleWidth;

    this.play();
  }
  private play(): void {
    if (this.picLists.length > 3) {
      this.timer = setTimeout(() => {
        this.swClickEvent();
        this.play();
      }, this.interval);
    }
  }

  private swClickEvent(index?: number): void {
    this.stop();
    if (this.animated) {
      return;
    }
    if(index) {
      this.moveIndex = index
    }
    if (this.moveIndex == this.picLists.length - 2) {
      this.moveIndex = 1;
    } else {
      this.moveIndex += 1;
    }
    this.animate(-this.singleWidth);
  }

  private animate(offset: number): void {
    if (offset == 0) {
      return;
    }
    this.animated = true;
    let _this: any = this,
      _time: number = 200,
      _interval: number = 10,
      speed: number = offset / (_time / _interval),
      _left: number = parseInt(_this.leftPos) + offset,
      go = function () {
        if (
          (speed < 0 && parseInt(_this.leftPos) > _left) ||
          (speed > 0 && parseInt(_this.leftPos) < _left)
        ) {
          _this.leftPos = parseInt(_this.leftPos) + speed;
          setTimeout(go, _interval);
        } else {
          _this.animated = false;
          _this.leftPos = _left;
          if (_left > -_this.singleWidth) {
            _this.leftPos = -_this.singleWidth * (_this.picLists.length - 2);
          }
          if (_left < -_this.singleWidth * (_this.picLists.length - 2)) {
            _this.leftPos = -_this.singleWidth;
          }
        }
      };
    go();
  }

  private stop(): void {
    clearTimeout(this.timer);
    this.timer = null;
  }
  private dotChangeEvent (index: number): void {
    this.swClickEvent(index)
  }

  mounted() {
    this.initPics();
    let win: any = window;
    win.onresize = () => {
      this.initPics();
    };
  }
}
